import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  state: {
    rootUrl: '',
    userInfo: {
      id: '',
      name: '',
      username: '',
      role: '',
      token: ''
    }
  },
  getters: {
  },
  mutations: {
    setUserInfo (state, userInfo) {
      this.state.userInfo = userInfo
    },
    clearUserInfo (state) {
      this.state.userInfo = {
        id: '',
        name: '',
        username: '',
        role: '',
        token: ''
      }
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [createPersistedState({ storage: window.localStorage })]
})
